export default "__VITE_ASSET__BgBfH4I3__"